import React, { FC } from 'react';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  children: ChildrenPropType;

  htmlFor?: string;
  className?: string;
};

/**
 * an ordinary having eslint issues but is in single file
 */
export const UiMereLabel: FC<Props> = ({ htmlFor, className, children }) => (
  /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
  <label htmlFor={htmlFor} className={className}>
    {children}
  </label>
);
